import { render, staticRenderFns } from "./printActual.vue?vue&type=template&id=24582fe1"
import script from "./printActual.vue?vue&type=script&lang=js"
export * from "./printActual.vue?vue&type=script&lang=js"
import style0 from "./printActual.vue?vue&type=style&index=0&id=24582fe1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports